// Public editorial content. Keep private sponsor/payment records out of this file.
export const league = {
  sponsorshipYear: 2027,
  email: "jay@smithfieldlittleleague.org",
  registrationUrl: null as string | null,
  lighting: "The lighting proposal is pending town council approval. A vote is expected on November 17, 2026.",
  impact: [
    { value: "550+", label: "Players across Spring, Summer & Fall in 2026" },
    { value: "35%", label: "Participation growth over the past two years" },
  ],
  banquet: { winner: "Alexandria K.", ticket: "001999", prize: 663.50, kicker: 100 },
};

export const archivePaths = ["/banquet", "/results", "/raffles/2026-banquet"];
export const archiveFragments = ["#raffle", "#details", "#rules"];
